
<template>
  <div class="section background">
    <div class="layout-content">

      <div class="content-bg">
        <!-- 开发教程 && 技术文档 -->
        <div class="button-list" v-for="item in data.buttonList" :key="item.id">
          <a class="button-text" :href="item.link" target="_blank">{{item.text}}</a>
        </div>

        <!-- 算法文档 && 案例集 -->
        <div class="case-list" v-for="item in data.case" :key="item.id">
          <img class="case-logo" :src="item.logo" alt="logo" />
          <a class="case-text" :href="item.link" target="_blank">{{item.text}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import VueTypes from 'vue-types'

export default {
  components: {
  },
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile'])
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

.background {
  padding: 100px 0 60px;
  background: #F5F7F8;

  @include mobile {
    padding: 30px 0 30px;
  }
}

.content-bg {
  display: flex; align-items: center;
  height: 200px;
  padding: 70px 80px;
  background: url('https://static001.geekbang.org/resource/image/c2/0e/c2e55d0d866196fd735c83fd3dd6780e.png') center / cover no-repeat;

  @include mobile {
    align-items: flex-start; flex-wrap: wrap; align-content: space-between;
    width: 100%; height: 132px;
    padding: 30px;
    background: url('https://static001.geekbang.org/resource/image/2e/23/2e988289d8073080515b20d6f5aa7b23.png') center / cover no-repeat;
  }
}

.button-list {
  margin-right: 50px;

  @include mobile {
    margin-right: 36px;
  }

  &:nth-child(2) .button-text {
    background: #3AB8FF;

    &:hover {
      background: #30A7E9;
    }
  }
}

.button-text {
  display: inline-block;
  width: 180px; height: 60px;
  font-size: 20px; font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  background: #8E6CFF;
  line-height: 60px;
  opacity: 0.9;

  &:hover {
    background: #7A53FF;
  }

  @include mobile {
    width: 90px; height: 30px;
    font-size: 11px;
    line-height: 30px;
  }
}

.case-list {
  height: 28px;
  margin-right: 40px;

  @include mobile {
    margin-right: 23px;
  }
}

.case-logo {
  display: inline-block;
  width: 28px; height: 28px;
  margin-right: 12px;

  @include mobile {
    width: 16px; height: 16px;
    margin-right: 8px;
  }
}

.case-text {
  color: #4ABDFF;
  font-size: 18px; font-weight: 400;
  line-height: 30px;
  vertical-align: super;

  &:hover {
    color: #30A7E9;
  }

  @include mobile {
    font-size: 11px;
    vertical-align: bottom;
  }
}

</style>
